import { categories, navItems, siteMeta } from "@/mocks/site";
import { scrollToSection } from "@/pages/home/utils";

interface SiteFooterProps {
  onJumpCategory: (key: string) => void;
}

export default function SiteFooter({ onJumpCategory }: SiteFooterProps) {
  return (
    <footer className="w-full bg-primary-900 text-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-file-shield-2-line text-lg leading-none"></i>
              </span>
              <span className="font-heading text-lg font-bold">{siteMeta.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-50/75">{siteMeta.intro}</p>
            <span className="mt-5 inline-flex items-center gap-2 rounded-full border border-background-50/25 px-3 py-1.5 font-label text-xs text-background-50/80">
              <i className="ri-refresh-line text-sm leading-none text-accent-400"></i>
              {siteMeta.updateNote}
            </span>
          </div>

          <nav className="lg:col-span-3" aria-label="页脚导航">
            <h3 className="font-heading text-sm font-bold text-background-50">站内导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(item.id);
                    }}
                    className="whitespace-nowrap font-label text-sm text-background-50/70 transition-colors hover:text-accent-400"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-sm font-bold text-background-50">主题分类</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <button
                    type="button"
                    onClick={() => onJumpCategory(cat.key)}
                    className="cursor-pointer whitespace-nowrap font-label text-sm text-background-50/70 transition-colors hover:text-accent-400"
                  >
                    {cat.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-sm font-bold text-background-50">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-3">
              <li>
                <a href={`mailto:${siteMeta.submitEmail}`} rel="nofollow" className="break-all font-label text-sm text-background-50/70 transition-colors hover:text-accent-400">
                  {siteMeta.submitEmail}
                </a>
              </li>
              <li>
                <a href={`mailto:${siteMeta.email}`} rel="nofollow" className="break-all font-label text-sm text-background-50/70 transition-colors hover:text-accent-400">
                  {siteMeta.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/15">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-3 px-4 py-5 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <p className="font-label text-xs leading-relaxed text-background-50/60">
            © 2026 {siteMeta.name} · 站内品牌均为化名示例，内容为用户投稿整理，仅供消费参考，不构成任何事实认定。
          </p>
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("top");
            }}
            className="flex items-center gap-1.5 whitespace-nowrap font-label text-xs text-background-50/70 transition-colors hover:text-accent-400"
          >
            <i className="ri-arrow-up-line text-sm leading-none"></i>
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}